import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ProdutoVideoModal } from '../../produto/produto-video-modal/produto-video-modal.component';

@Component({
  selector: 'btn-video',
  templateUrl: './btn-video.component.html',
  styleUrls: ['./btn-video.component.scss']
})
export class BtnVideoComponent implements OnInit {

  @Input("link") link  = null;

  constructor(
    private dialog: MatDialog
  ){ }
  
  /**
   * 
   * Open Video
   * 
   */
  _openVideo(){

    this.dialog.open(
      ProdutoVideoModal,{
        width: "800px",
        height: "auto",
        disableClose: true, 
        data: {
          video: this.link
        }
      }
    )

  }
  /**
   * 
   * Incializa as Funções
   * 
   */
  ngOnInit():void{}

}
